<template>
  <ChartNormal
    size="12"
    offset="0"
    title="Inventory Status"
    chart="column"
    chartType="inventory_status"
    :isCity="false"
    :withDate="true"
    :withFinancial="false"
    :inventoryStatus="true"
  />
</template>

<script>
import ChartNormal from "../../../components/chart/chartNormal";

export default {
  name: "InventoryStatus",
  components: {
    ChartNormal
  }
};
</script>